/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

/**
 * 包含待检测文本 'text' 的JSON对象
 */
export type PostSensitiveWordQuickCheckRequest = { text: string };

export const PostSensitiveWordQuickCheckRequest$zodSchema: z.ZodType<
  PostSensitiveWordQuickCheckRequest
> = z.object({
  text: z.string(),
}).describe("包含待检测文本 'text' 的JSON对象");

export type PostSensitiveWordQuickCheckDetails = {};

export const PostSensitiveWordQuickCheckDetails$zodSchema: z.ZodType<
  PostSensitiveWordQuickCheckDetails
> = z.object({});

/**
 * 请求体无效或文本为空
 */
export type PostSensitiveWordQuickCheckBadRequestResponseBody = {
  code?: string | undefined;
  details?: PostSensitiveWordQuickCheckDetails | undefined;
  message?: string | undefined;
};

export const PostSensitiveWordQuickCheckBadRequestResponseBody$zodSchema:
  z.ZodType<PostSensitiveWordQuickCheckBadRequestResponseBody> = z.object({
    code: z.string().optional(),
    details: z.lazy(() => PostSensitiveWordQuickCheckDetails$zodSchema)
      .optional(),
    message: z.string().optional(),
  }).describe("请求体无效或文本为空");

/**
 * 成功响应
 */
export type PostSensitiveWordQuickCheckResponseBody = {
  status?: string | undefined;
  original_text?: string | undefined;
  masked_text?: string | undefined;
  forbidden_words?: Array<string> | undefined;
};

export const PostSensitiveWordQuickCheckResponseBody$zodSchema: z.ZodType<
  PostSensitiveWordQuickCheckResponseBody
> = z.object({
  forbidden_words: z.array(z.string()).optional(),
  masked_text: z.string().optional(),
  original_text: z.string().optional(),
  status: z.string().optional(),
}).describe("成功响应");

export type PostSensitiveWordQuickCheckResponse =
  | PostSensitiveWordQuickCheckResponseBody
  | PostSensitiveWordQuickCheckBadRequestResponseBody;

export const PostSensitiveWordQuickCheckResponse$zodSchema: z.ZodType<
  PostSensitiveWordQuickCheckResponse
> = z.union([
  z.lazy(() => PostSensitiveWordQuickCheckResponseBody$zodSchema),
  z.lazy(() => PostSensitiveWordQuickCheckBadRequestResponseBody$zodSchema),
]);
